<template>
  <div class="login-page">
    <el-card class="login-card">
      <template #header>
        <div class="card-header">
          <h2>系统登录</h2>
          <p class="login-system-title">
            <span class="brand-love">爱教务</span><span class="brand-sub">智能教务系统</span>
          </p>
        </div>
      </template>

      <el-form :model="form" label-position="top" @submit.prevent="handleLogin">
        <el-form-item label="用户名">
          <el-input v-model="form.username" placeholder="请输入用户名" autocomplete="username" />
        </el-form-item>

        <el-form-item label="密码">
          <el-input
            v-model="form.password"
            type="password"
            placeholder="请输入密码"
            show-password
            autocomplete="current-password"
            @keyup.enter="handleLogin"
          />
        </el-form-item>

        <div style="margin-bottom: 18px; text-align: left;">
          <el-checkbox v-model="rememberMe">记住密码</el-checkbox>
        </div>

        <el-button class="login-btn" type="primary" :loading="loading" @click="handleLogin">
          登录
        </el-button>
        <div class="register-link">
          没有账号？<el-link type="primary" @click="router.push('/register')">立即注册</el-link>
          <span class="divider">|</span>
          <el-link type="info" @click="handleForgotPassword">忘记密码</el-link>
        </div>
        <div style="margin-top: 15px; text-align: center;">
          <el-link type="warning" @click="router.push('/exam-clock')" style="font-weight: 600; font-size: 13.5px;">
            ⏰ 免登录使用监考时钟大屏
          </el-link>
        </div>
      </el-form>
    </el-card>
  </div>
</template>

<script setup>
import { reactive, ref, onMounted } from 'vue'
import { useRouter } from 'vue-router'
import { ElMessage, ElMessageBox } from 'element-plus'
import { authApi } from '@/api'
import { setToken, setUser } from '@/utils/auth'

const router = useRouter()
const loading = ref(false)
const rememberMe = ref(true)
const form = reactive({
  username: '',
  password: ''
})

onMounted(() => {
  const savedUsername = localStorage.getItem('remembered_username')
  const savedPassword = localStorage.getItem('remembered_password')
  if (savedUsername) {
    form.username = savedUsername
    if (savedPassword) {
      form.password = savedPassword
      rememberMe.value = true
    }
  }
})

const handleLogin = async () => {
  if (!form.username || !form.password) {
    ElMessage.warning('请输入用户名和密码')
    return
  }

  loading.value = true
  try {
    const data = await authApi.login(form)
    setToken(data.access_token)
    setUser(data.user)

    if (rememberMe.value) {
      localStorage.setItem('remembered_username', form.username)
      localStorage.setItem('remembered_password', form.password)
    } else {
      localStorage.removeItem('remembered_username')
      localStorage.removeItem('remembered_password')
    }

    ElMessage.success('登录成功')
    router.replace('/portal')
  } finally {
    loading.value = false
  }
}

const handleForgotPassword = () => {
  ElMessageBox.alert('忘记密码请联系QQ：1072677403', '找回密码提示', {
    confirmButtonText: '确定',
    type: 'info'
  })
}
</script>

<style scoped>
.login-page {
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(135deg, #eef2ff 0%, #e0f2fe 100%);
  padding: 20px;
}

.login-card {
  width: 100%;
  max-width: 420px;
  border-radius: 16px;
}

.card-header {
  text-align: center;
}

.card-header h2 {
  font-size: 22px;
  margin-bottom: 4px;
  color: #1f2937;
}

.card-header p {
  font-size: 14px;
  color: #6b7280;
}

.login-btn {
  width: 100%;
  margin-top: 8px;
}

.register-link {
  margin-top: 16px;
  text-align: center;
  font-size: 14px;
  color: #6b7280;
}

.divider {
  margin: 0 8px;
  color: #d1d5db;
}

.login-system-title {
  font-size: 15px;
  margin-top: 4px;
}
.brand-love {
  background: linear-gradient(135deg, #ff4e50 0%, #f9d423 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  font-weight: 800;
  margin-right: 3px;
}
.brand-sub {
  color: #6b7280;
  font-weight: 600;
}
</style>
